import { useQuery } from '@tanstack/react-query';
import { HttpError, RQAPICallWithData } from 'store/APIClient';
import { camelize } from 'helpers/syntaxHelper';
import { STALE_TIME } from 'business/constants';
import { getQueryString } from 'helpers/chartHelper';
import { transformQueryToDataQuery } from 'helpers/queryHelpers';

export type ChartMaxValueQueryPayload = {
    chartKey: number;
    metrics?: QueryMetricT[];
    maxValueField?: string;
    filters?: QueryFilterT[];
    shouldTriggerMaxValueQuery: boolean;
    publicToken?: string;
    dashboardFilters?: DashboardFilterT[];
    disableDashboardFilters: boolean;
};

export const useGetMaxValueFromEndpoint = (
    payload: ChartMaxValueQueryPayload,
    query: QueryT,
    endpoint: string,
    metric: QueryMetricT | undefined,
    disableDashboardFilters: boolean,
    dashboardFilters: DashboardFilterT[] = [],
) => {
    const { chartKey, maxValueField, shouldTriggerMaxValueQuery } = payload;
    const queryKey = [
        'chart',
        chartKey,
        'maxValue',
        maxValueField,
        getQueryString(query),
        dashboardFilters,
        disableDashboardFilters,
    ];
    return useQuery<number | undefined, HttpError>({
        queryKey: queryKey,

        queryFn: async () => {
            const response = await RQAPICallWithData<{
                columns: ResponseColumnT[];
                data: Record<string, number>[];
            }>({
                endpoint,
                method: 'POST',
                body: transformQueryToDataQuery(query),
            });
            const { data } = response.content.data;
            if (!data || data.length === 0) {
                console.warn(
                    `No data for runMaxValueQuery with chart ${chartKey}, skipping setDynamicMaxValue`,
                );
            }
            const result =
                data?.length > 0
                    ? data[0][camelize(maxValueField ?? '')]
                    : undefined;
            return result;
        },

        enabled: shouldTriggerMaxValueQuery && Boolean(metric),
        staleTime: STALE_TIME,
    });
};
